import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Toaster } from 'sonner';

const Layout = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen flex flex-col bg-islamic-pearl">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      {!hideFooter && <Footer />}
      <Toaster position="top-right" />
    </div>
  );
};

export default Layout;
